<template>
  <div class="bg-n-800 text-n-0 px-8 h-screen pb-safe flex items-center justify-center">
    <div class="flex flex-col items-center text-center gap-4">
      <div v-if="image" class="w-40 h-40">
        <img :src="image" class="w-full h-full" />
      </div>
      <div class="heading-2">
        {{ title }}
      </div>
      <div>{{ message }}</div>
      <l-button
        v-if="confirmText"
        size="medium"
        class="w-full max-w-72 mt-6"
        @click="emit('confirm')"
      >
        {{ confirmText }}
      </l-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LButton } from '@last/core-ui/paprika'

defineProps<{
  title: string
  message: string
  confirmText?: string | null
  image?: string | null
}>()

const emit = defineEmits<{
  confirm: []
}>()
</script>
